<template>
    <div>
        <div>
            <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter flowStatistics"
                label-position="left" @submit.native.prevent>
                <el-form-item label="核算周期：">
                    <el-date-picker v-model="searchForm.month" type="month" placeholder="选择结算月份"
                        value-format="yyyy-MM"></el-date-picker>
                </el-form-item>

                <el-form-item label="ICCID：">
                    <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getFlowStatisticsHandler"
                        clearable></el-input>
                </el-form-item>
                <el-form-item label="所属代理商：">
                    <el-select v-model="searchForm.agentId" filterable placeholder="请选择或输入关键字" clearable>
                        <el-option v-for="item in agentsOption" :value="item.agentId" :key="item.agentId"
                            :label="item.agentName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商：">
                    <el-select v-model="searchForm.supplierCode" placeholder="请选择" clearable filterable>
                        <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id"
                            :label="item.supplierName"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="使用流量：">
                    <el-input  v-model.trim="searchForm.dataAmount" @keyup="formatDataAmount()" 
                        @blur="formatDataAmount()" clearable>
                        <template slot="prepend">大于等于</template>
                        <template slot="append">M</template>
                    </el-input>
                </el-form-item> -->

                <el-form-item class="btnArea">
                    <el-button type="primary" @click="getFlowStatisticsHandler" icon="el-icon-search">查 询</el-button>
                    <el-button type="primary" @click="excelSelect()" icon="el-icon-download">EXCEL导入</el-button>
                    <el-button type="primary" @click="exportAdminSimInfoHandle()">导出数据</el-button>
                </el-form-item>
            </el-form>
        </div>



        <el-table :data="everyDayTbpg.tableData" border height="600">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="iccid" label="ICCID"></el-table-column>
            <el-table-column prop="intoNo" label="接入号"></el-table-column>
            <el-table-column prop="month" label="核算月份"></el-table-column>
            <el-table-column prop="totalUse" label="核算流量(MB)"></el-table-column>
            <el-table-column prop="salePrice" label="核算价格（元）"></el-table-column>
            <el-table-column prop="agentName" label="代理商"></el-table-column>
            <el-table-column prop="supplierName" label="供应商"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="everyDayTbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="everyDayTbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="everyDayTbpg.total">
        </el-pagination>


        <el-dialog :append-to-body="true" title="批量导入" :visible.sync="batchOptVisible1" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="batchOptForm1" :model="batchOptForm1" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/other/import/poolData')" :headers="setHeader()"
                        :auto-upload="false" :data="batchOptForm1" :on-change="handleChange" :on-success='handleSuccess'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="downPdf()">导入模板</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="核算周期：">
                    <el-date-picker v-model="batchOptForm1.countMonth" type="month" placeholder="选择结算月份"
                        value-format="yyyy-MM"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureBatchChgStateHandler1">确 定</el-button>
            </div>
        </el-dialog>



    </div>
</template>
<script>
import { flowStatistics, flowEveryDayDetail, flowEveryMonthDetail, flowStatisticsExport } from '@/api/csm.js'
import common from '@/utils/common.js'
var echarts = require('echarts');      // 引入 ECharts 主模块
export default {
    data() {
        return {
            batchOptVisible1: false,
            batchOptForm1: {
                countMonth: ''
            },
            searchForm: {
                agentName: '',
                iccid: null,
                countMonth: '',
                time: null,
                into_no: null,
                supplierCode: '',
                basePkgGroup: '',
                dataAmount: null,
            },
            agentsOption: [],
            pkgGroup: [],
            //每月流量详情表
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            //每日流量详情表
            everyDayTbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            thisMonth: '',
            activeName: 'everyMonthTable',
            everyDayAmountData: [],
            branchSupplierOption: [],
            monthFlow: [{
                createTime: '',
                dataAmount: ''
            }],

            stopMessage: '0',
            moreThanNumber: '0',
            sumTotoalData: '0',
            totalOutData: '0'

        }
    },
    methods: {
        exportAdminSimInfoHandle() {//导出excel文件
            var data = JSON.parse(JSON.stringify(this.searchForm));
            data.token = localStorage.getItem('token');
            data.pageSize = 10000;
            data.prePageNum = 10000;
            common.sysRequest('excels/admin/sim/all/pool/data', data, 'post').then(res => {
                if (res.data.code == 200) {
                    this.$message.success('下载中，请稍后在下载管理中查询');
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },

        sureBatchChgStateHandler1() {
            this.$refs.batchOptForm1.validate(valid => {
                if (valid) {
                    this.$refs.upload.submit();
                }
            });
        },
        handleSuccess(res) {
            if (res.code == 200) {
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.cancel();
            this.getFlowStatisticsHandler();
            this.$refs.upload.clearFiles();
        },


        downPdf() {
            var link = document.createElement('a');
            link.setAttribute('download', '');
            link.href = '../../../doc/池组流量导入.xls';
            link.click();
        },
        cancel() {
            this.batchOptVisible1 = false;
            this.$refs.batchOptForm1.resetFields();
        },
        excelSelect() {
            this.batchOptVisible1 = true;
        },

        getFlowStatisticsHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('sim/other/poll/datalist', data, 'post').then(res => {
                common.listCallback(this, res, 'everyDayTbpg');
            })



        },

        formatDataAmount() {
            this.searchForm.dataAmount = this.searchForm.dataAmount.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },

        //获取每日流量数据
        getFlowEveryDayHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            if (data.dataAmount) {
                data.dataAmount = data.dataAmount * 1024;
            }
            data.iccid = this.currentIccic;
            flowEveryDayDetail(data).then(res => {
                common.listCallback(this, res, 'everyDayTbpg');
                this.activeName = 'everyDayTable';
            })
        },

        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'orderMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },

        exportInfoHandle() {//导出excel文件
            this.$confirm("确定要导出吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let param = this.searchForm;
                flowStatisticsExport(param).then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch(err => console.error(err));
            }).catch(() => { });
        },


        drawFlowStatisticsChart(elementId, everyDayAmountData) {
            let dataAxis = [];
            let data = [];
            let yMax = 500;
            let dataShadow = [];
            let myChart = echarts.init(document.getElementById(elementId));



            for (let i = 0; i < everyDayAmountData.length; i++) {
                dataAxis.push(everyDayAmountData[i].createTime);
                data.push(everyDayAmountData[i].dataAmount);
            }

            yMax = Math.max(...data);

            for (let i = 0; i < data.length; i++) {
                dataShadow.push(yMax);
            }


            let option = {
                title: {
                    text: '每日流量统计',
                },
                xAxis: {
                    data: dataAxis,
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        show: false
                    },
                    z: 10
                },
                yAxis: {
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        textStyle: {
                            color: '#999'
                        }
                    }
                },
                dataZoom: [
                    {
                        type: 'inside'
                    }
                ],
                series: [
                    { // For shadow
                        type: 'bar',
                        itemStyle: {
                            normal: { color: 'rgba(0,0,0,0.05)' }
                        },
                        barGap: '-100%',
                        barCategoryGap: '40%',
                        data: dataShadow,
                        animation: false,
                    },
                    {
                        type: 'bar',
                        label: {
                            normal: {
                                show: true,
                                position: 'insideTop'
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#83bff6' },
                                        { offset: 0.5, color: '#188df0' },
                                        { offset: 1, color: '#188df0' }
                                    ]
                                )
                            },
                            emphasis: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#2378f7' },
                                        { offset: 0.7, color: '#2378f7' },
                                        { offset: 1, color: '#83bff6' }
                                    ]
                                )
                            }
                        },
                        data: data
                    }
                ]
            };

            myChart.setOption(option);
        },

        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getFlowStatisticsHandler();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val
            this.getFlowStatisticsHandler();
        },
    },
    created() {
        this.thisMonth = this.dateFormat("yyyy-MM", new Date());
        common.getSupplierOptsCom(this, 'branchSupplierOption');
        common.sysRequest('/agent/listOption', {}, 'post').then(res => {
            if (res.data.code == 200) {
                this.agentsOption = res.data.data;
            }

        });
    },

    mounted() {
        this.getFlowStatisticsHandler();
    },

    updated: function () {

    },

    watch: {

    }
}
</script>

<style>
.flowStatistics .el-input-group__prepend,
.flowStatistics .el-input-group__append {
    background-color: #f5f5f5;
}

.flowStatistics .el-form-item__content {
    width: 250px;
}
</style>

<style  lang="less" scoped>
.forTbFilter {
    display: inline-block;

    .btnArea {
        display: inline-block;
        margin-left: 30px;

    }
}

.stopMessage {
    font-size: 18px;
    margin: 0 0 10px 0;

    span {
        color: #ea2929;
        margin-right: 60px;

    }
}
</style>